module.exports = __webpack_public_path__ + "img/2.6ee79d7f.jpg";